














import { Component, Vue } from 'vue-property-decorator';
import GameArea from '@/components/GameArea.vue';
import NavigationBar from '@/components/NavigationBar.vue';
import PopupLayer from '@/components/PopupLayer.vue';
import PrintPage from '@/components/print/PrintPage.vue';
import PopupOverlay from '@/components/PopupOverlay.vue';

@Component({
  components: {
    GameArea,
    NavigationBar,
    PopupLayer,
    PrintPage,
    PopupOverlay,
  },
})
export default class App extends Vue {}
